import { render, staticRenderFns } from "./RegionsAdmin.vue?vue&type=template&id=72c5408e&scoped=true"
import script from "./RegionsAdmin.vue?vue&type=script&lang=js"
export * from "./RegionsAdmin.vue?vue&type=script&lang=js"
import style0 from "./RegionsAdmin.vue?vue&type=style&index=0&id=72c5408e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5408e",
  null
  
)

export default component.exports